import { Button, Col, Row } from 'reactstrap';

interface FallbackPageProps {
  hideGoHome?: boolean;
  error?: unknown;
  // When provided (e.g. from a Next.js error.tsx boundary), renders a "Try Again"
  // action that re-renders the failed segment without a full page reload.
  reset?: () => void;
}

const FallbackPage = ({ hideGoHome, error, reset }: FallbackPageProps) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
      }}
    >
      <Row className="mb-3">
        <Col>
          <div className="nothing-card-xl">
            <div className="nothing-card-xl--icon">
              <svg
                width="110"
                height="108"
                viewBox="0 0 110 108"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="110" height="108" rx="54" fill="#FFF4EC" />
                <path
                  d="M58.427 63.9492L55 60.6328L51.5731 63.9492C49.684 65.7773 46.6082 65.7773 44.7192 63.9492C42.8301 62.1211 42.8301 59.1562 44.7192 57.3164L48.1461 54L44.7192 50.6836C42.8301 48.8555 42.8301 45.8789 44.7192 44.0508C46.6082 42.2227 49.684 42.2227 51.5731 44.0508L55 47.3672L58.427 44.0508C60.316 42.2227 63.3797 42.2227 65.2809 44.0508C67.1699 45.8789 67.1699 48.8555 65.2809 50.6836L61.8539 54L65.2809 57.3164C67.1699 59.1445 67.1699 62.1094 65.2809 63.9492C63.3797 65.7773 60.316 65.7773 58.427 63.9492ZM55.8598 58.1484L60.1465 62.2969C61.091 63.2109 62.6289 63.2109 63.5735 62.2969C64.518 61.3828 64.518 59.8945 63.5735 58.9805L59.2867 54.832C58.8145 54.375 58.8145 53.6367 59.2867 53.1797L63.5735 49.0313C64.518 48.1172 64.518 46.6289 63.5735 45.7148C62.6289 44.8008 61.091 44.8008 60.1465 45.7148L55.8598 49.8633C55.3875 50.3203 54.6246 50.3203 54.1524 49.8633L49.8656 45.7148C48.9211 44.8008 47.3832 44.8008 46.4387 45.7148C45.4942 46.6289 45.4942 48.1172 46.4387 49.0313L50.7254 53.1797C51.1977 53.6367 51.1977 54.375 50.7254 54.832L46.4387 58.9805C45.4942 59.8945 45.4942 61.3828 46.4387 62.2969C47.3832 63.2109 48.9211 63.2109 49.8656 62.2969L54.1524 58.1484C54.6125 57.6914 55.3875 57.6797 55.8598 58.1484Z"
                  fill="#FFA064"
                />
                <path
                  d="M69.4102 29.8594C70.4133 29.8594 71.2266 29.0724 71.2266 28.1016C71.2266 27.1307 70.4133 26.3438 69.4102 26.3438C68.407 26.3438 67.5938 27.1307 67.5938 28.1016C67.5938 29.0724 68.407 29.8594 69.4102 29.8594Z"
                  fill="#FFA064"
                />
                <path
                  d="M31.8711 32.2031C32.8743 32.2031 33.6875 31.4161 33.6875 30.4453C33.6875 29.4745 32.8743 28.6875 31.8711 28.6875C30.8679 28.6875 30.0547 29.4745 30.0547 30.4453C30.0547 31.4161 30.8679 32.2031 31.8711 32.2031Z"
                  fill="#FFA064"
                />
                <path
                  d="M31.8711 77.9062C32.8743 77.9062 33.6875 77.1193 33.6875 76.1484C33.6875 75.1776 32.8743 74.3906 31.8711 74.3906C30.8679 74.3906 30.0547 75.1776 30.0547 76.1484C30.0547 77.1193 30.8679 77.9062 31.8711 77.9062Z"
                  fill="#FFA064"
                />
                <path
                  d="M78.4922 32.2031C79.161 32.2031 79.7031 31.6785 79.7031 31.0312C79.7031 30.384 79.161 29.8594 78.4922 29.8594C77.8234 29.8594 77.2812 30.384 77.2812 31.0312C77.2812 31.6785 77.8234 32.2031 78.4922 32.2031Z"
                  fill="#FFA064"
                />
                <path
                  d="M80.9141 72.0469C81.5828 72.0469 82.125 71.5222 82.125 70.875C82.125 70.2278 81.5828 69.7031 80.9141 69.7031C80.2453 69.7031 79.7031 70.2278 79.7031 70.875C79.7031 71.5222 80.2453 72.0469 80.9141 72.0469Z"
                  fill="#FFA064"
                />
                <path
                  d="M42.1641 31.0312C42.8328 31.0312 43.375 30.5066 43.375 29.8594C43.375 29.2122 42.8328 28.6875 42.1641 28.6875C41.4953 28.6875 40.9531 29.2122 40.9531 29.8594C40.9531 30.5066 41.4953 31.0312 42.1641 31.0312Z"
                  fill="#FFA064"
                />
                <path
                  d="M72.4375 80.25C73.1063 80.25 73.6484 79.7253 73.6484 79.0781C73.6484 78.4309 73.1063 77.9062 72.4375 77.9062C71.7687 77.9062 71.2266 78.4309 71.2266 79.0781C71.2266 79.7253 71.7687 80.25 72.4375 80.25Z"
                  fill="#FFA064"
                />
                <path
                  d="M43.375 81.4219C44.0438 81.4219 44.5859 80.8972 44.5859 80.25C44.5859 79.6028 44.0438 79.0781 43.375 79.0781C42.7062 79.0781 42.1641 79.6028 42.1641 80.25C42.1641 80.8972 42.7062 81.4219 43.375 81.4219Z"
                  fill="#FFA064"
                />
                <path
                  d="M54.3945 80.2617L31.8105 67.6406C31.4352 67.4297 31.2051 67.043 31.2051 66.6211V41.3789C31.2051 40.957 31.4352 40.5703 31.8105 40.3594L54.3945 27.7383C54.7699 27.5273 55.2301 27.5273 55.6055 27.7383L78.1895 40.3594C78.5648 40.5703 78.7949 40.957 78.7949 41.3789V66.6211C78.7949 67.043 78.5648 67.4297 78.1895 67.6406L55.6055 80.2617C55.2301 80.4727 54.7699 80.4727 54.3945 80.2617ZM33.627 65.9414L55 77.8945L76.373 65.9531V42.0586L55 30.1055L33.627 42.0586V65.9414Z"
                  fill="#FFA064"
                />
              </svg>
            </div>
            <h4 className="h3">Uh oh, something went wrong</h4>
            <p className="p-3 text-center">
              We are experiencing unexpected behavior. But we anticipate it won&apos;t be long.
            </p>
            <div className="nothing-action">
              {reset ? (
                <Button onClick={reset} className="ls-button ls-button-secondary has-secondary">
                  Try Again
                </Button>
              ) : (
                ''
              )}
              {!hideGoHome ? (
                <Button
                  onClick={() => {
                    window.location.href = window.location.origin;
                  }}
                  className="ls-button ls-button-secondary has-secondary"
                >
                  Go Home
                </Button>
              ) : (
                ''
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FallbackPage;
